import * as api from '@/store/api';
import { OwnerFolder } from '@/store/models/LetterOwner/OwnerFolder';

export async function saveComment(comment: string,possessionId: string,id: string,dateTime: Date,CommentOwnerId: string,smsAlertTime?: Date): Promise<any>{
    try {
        const data = {
            Id:id,
            PossessionId: possessionId,
            Comment:comment,
            SmsAlertTime:smsAlertTime,
            DateTime:dateTime,
            CommentOwner:CommentOwnerId
        };
        const serverResult =  await api.batisAutomationApi.post("/LetterPossessionComment",data);
        return serverResult.data; 
    } 
    catch (error) {
        console.log(error);
    }
}
export async function DeleteComment(comment: string,possessionId: string,id: string,dateTime: Date,CommentOwnerId: string,smsAlertTime?: Date): Promise<any>{
    try {
        const data = {
            Id:id,
            PossessionId: possessionId,
            Comment:comment,
            SmsAlertTime:smsAlertTime,
            DateTime:dateTime,
            CommentOwner:CommentOwnerId
        };
        const serverResult =  await api.batisAutomationApi.post("/LetterPossessionComment/DeleteComment",data);
        return serverResult.data; 
    } 
    catch (error) {
        console.log(error);
    }
}

export async function ReadComments(ownerId: string,possessionId: string): Promise<any>{
    try {
        const data = {
            OwnerId: ownerId,
            PossesstionId:possessionId
        };
        const serverResult =  await api.batisAutomationApi.post("/LetterPossessionComment/ReadComments",data);
        return serverResult; 
    } 
    catch (error) {
        console.log(error);
    }
}


export async function ReadSingleComment(id: string): Promise<any>{
    try {
        const data = {
            Id:id,
        };
        const serverResult =  await api.batisAutomationApi.post("/LetterPossessionComment/ReadSingleComment",data);
        return serverResult.data; 
    } 
    catch (error) {
        console.log(error);
    }
}




